var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"patient-hover",staticStyle:{"cursor":"pointer"},attrs:{"title":"Ver información del paciente"},on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_vm._v(" Patient component ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }